import React, { useEffect, useState } from 'react';

const CyberTooltip = ({ 
  show, 
  text, 
  style,
  className,
  glowColor = '#33ff33',
  backgroundColor = 'rgba(0, 0, 0, 0.95)',
  textColor = '#33ff33',
  borderColor = '#33ff33',
  fontSize = '12px',
  padding = '8px 12px',
  offset = { x: 10, y: 10 }
}) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (show) {
        setPosition({
          x: e.clientX + offset.x,
          y: e.clientY + offset.y
        });
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [show, offset.x, offset.y]);

  if (!show) return null;

  return (
    <div
      className={`cyber-tooltip ${className || ''}`}
      style={{
        position: 'fixed',
        left: position.x,
        top: position.y,
        background: backgroundColor,
        border: `1px solid ${borderColor}`,
        borderRadius: '4px',
        padding,
        color: textColor,
        fontSize,
        fontFamily: 'IBM BIOS, monospace',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        zIndex: 10000,
        boxShadow: `0 0 10px ${glowColor}`,
        textShadow: `0 0 5px ${glowColor}`,
        ...style
      }}
    >
      {text}
    </div>
  );
};

export default CyberTooltip;